module.exports = __webpack_public_path__ + "static/anna-4bd3250a3013f4a04e8b83dd7c85ee3c.png";